// extracted by mini-css-extract-plugin
export default {"legendIndicator":"Lna-z","legendNew":"Mna-z"};